import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=3751cb9c&scoped=true"
import script from "./content-item.vue?vue&type=script&lang=ts"
export * from "./content-item.vue?vue&type=script&lang=ts"
import style0 from "./content-item.vue?vue&type=style&index=0&id=3751cb9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751cb9c",
  null
  
)

export default component.exports